import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import {
  CloseIcon,
  Box as DarkBox,
  IconButton,
  tokenPrefix,
} from '@hivewatch/dark'

import { useAppDispatch } from '@/redux/hooks'
import { toggleIncidentTraceLogDrawer } from '@/redux/ui/uiSlice'

export const TraceLogHeader = () => {
  const dispatch = useAppDispatch()
  const mode = useLightMode()
  const { t } = useTranslation()

  // Rendered inside TraceLogContent's DarkProvider, so no provider of its
  // own — see WorkflowDrawerHeader for the standalone variant.
  const prefix = tokenPrefix(mode)
  return (
    <DarkBox
      alignItems='center'
      borderBottom='1px solid'
      borderColor={`${prefix}border.subtle`}
      display='flex'
      flexShrink={0}
      gap='12px'
      justifyContent='space-between'
      px='24px'
      py='16px'
    >
      <DarkBox
        as='span'
        color={`${prefix}text.primary`}
        fontFamily="'Soehne Kraftig', 'Söhne Kräftig', sans-serif"
        fontSize='20px'
        fontWeight='500'
        lineHeight='28px'
        whiteSpace='nowrap'
      >
        {t('incidents:drawer_trace_log_title')}
      </DarkBox>
      <IconButton
        _active={{ bg: 'transparent' }}
        aria-label='close trace log drawer'
        colorScheme={mode}
        dimension={36}
        hoverBgColor='transparent'
        icon={<CloseIcon size={11} />}
        onClick={() => dispatch(toggleIncidentTraceLogDrawer())}
      />
    </DarkBox>
  )
}
